import React, { useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch, useSelector } from 'react-redux'
import Wysiwyg from '../../elements/form/Wysiwyg'
import { createStudentFeedback } from '../../../store/actions/studentFeedbackActions'

const NewStudentFeedback = ({student, close}) => {
    const feedbackSelector = useSelector(state => state.feedback)
    const [feedbackBody, setFeedbackBody] = useState('')
    const dispatch = useDispatch()
    // const [validationErrors, setValidationErrors] = useState({})

    // const validateForm = () => {
    //     let errors = {}

    //     if(!feedbackBody || feedbackBody === '') {
    //         errors.feedback = true
    //     }

    //     setValidationErrors(errors)
    // }

    const pushFeedback = () => {
        if(!feedbackBody || feedbackBody === '') {
            return
        }
        try {
            const payload = {
                feedback: feedbackBody,
                student: student
            }
            dispatch(createStudentFeedback(payload))

        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className=''>
            <div className='w-full relative'>
                <div className='borderless'>
                    <Wysiwyg 
                        fieldTitle=""
                        initialValue={''}
                        
                        updateValue={
                            (value)=>{
                                setFeedbackBody(value)
                            }
                        }
                    />
                </div>
            </div>
            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Post Feedback`}
                    buttonAction={()=>{pushFeedback()}}
                    processing={feedbackSelector.creatingStudentFeedback}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default NewStudentFeedback